<template>
  <div class="my-4 flex rounded-lg border-2 border-light-gray px-4 py-2">
    <div class="flex w-full flex-col md:grid md:grid-cols-12 md:items-center">
      <img
        class="col-span-1 hidden md:block"
        src="@/assets/highway-uncheck-badge.svg"
        alt="highway check badge"
      />
      <div class="col-span-7 flex flex-col md:flex-row md:items-center">
        <div>
          <p class="text-left text-1lg text-dark-gray">
            {{ capitalizeParagraph(connectedCarrier.carrier.legal_name) }}
            <img
              class="inline md:hidden"
              src="@/assets/highway-uncheck-badge.svg"
              alt="highway check badge"
            />
          </p>
        </div>
        <p class="my-1 text-left text-xxs text-body-color md:ml-3">
          {{ identifiers }}
        </p>
      </div>
      <div class="col-span-4 flex items-start justify-self-end md:items-center">
        <small class="mr-4 flex-1 text-left text-xxs text-body-color">
          Connected {{ createdDate }}
        </small>
        <button
          class="hidden justify-center rounded hover:bg-light-gray md:flex"
          @click="sendRequestToRemoveConnection(connectedCarrier.id)"
        >
          <img
            src="@/assets/trash-dark-icon.svg"
            alt="delete carrier connection"
          />
        </button>
      </div>
    </div>
    <div class="block w-11 self-center justify-self-center md:hidden">
      <button
        class="rounded hover:bg-light-gray"
        @click="sendRequestToRemoveConnection(connectedCarrier.id)"
      >
        <img
          src="@/assets/trash-dark-icon.svg"
          alt="delete carrier connection"
        />
      </button>
    </div>
  </div>
</template>
<script>
import moment from 'moment';

import WordTools from '@/mixins/wordTools';

export default {
  name: 'ConnectedCarrierCard',
  mixins: [WordTools],
  props: {
    connectedCarrier: {
      type: Object,
      require: true,
    },
  },
  emits: ['delete-connection'],
  data() {
    return {};
  },
  computed: {
    identifiers() {
      const identifiersList = this.connectedCarrier.carrier.identifiers.map(
        (identifier) => {
          return ` ${identifier.is_type}# ${identifier.value}`;
        }
      );
      return identifiersList.join('  ');
    },
    creatorName() {
      return `${this.request.connectedCarrier.first_name} ${this.connectedCarrier.creator.last_name}`;
    },
    createdDate() {
      return this.displayDate(this.connectedCarrier.created_at);
    },
  },
  async created() {},
  methods: {
    displayDate(date) {
      if (date) {
        return moment(date, 'YYYY-MM-DD').format('M/D/YY');
      }
    },
    async sendRequestToRemoveConnection(connectionId) {
      this.$emit('delete-connection', connectionId);
    },
  },
};
</script>
<style scoped></style>
